<template>
  <div>
    <modal
      :show.sync="showModal"
      modal-classes="modal-dialog-centered modal-lg "
      body-classes="pt-1"
      @close="closeModalHistory()"
      no-close-on-backdrop
    >
      <template slot="header">
        <h4 class="subtitle d-flex align-items-center">
          <i class="flaticon-wall-clock-1 mr-2 d-inline-flex"></i>History - Rate
        </h4>
      </template>

      <div v-if="loader">
        <div class="text-center p-5">
          <h4><strong>Loading History...</strong></h4>

          <div id="loaderInner">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <div class="box-timeline" v-else>
        <div
          class="timeline timeline-one-side"
          data-timeline-content="axis"
          data-timeline-axis-style="dashed"
        >
          <div v-for="data in histories" class="timeline-block">
            <span class="timeline-step badge" :class="getBadge(data.change)">
              <i :class="getIcon(data.change)"></i>
            </span>

            <div class="timeline-content">
              <div class="row">
                <div
                  class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-12 align-self-center"
                >
                  <div class="text-group">
                    <span class="text-min-flex">
                      {{
                        formatDate(
                          data.created_at,
                          data.module.ref.branch.timezone
                        )
                      }}
                      at
                      {{
                        formatTime(
                          data.created_at,
                          data.module.ref.branch.timezone
                        )
                      }}</span
                    >
                  </div>

                  <span class="title">{{ data.change }}</span>

                  <div class="text-group">
                    <span class="text-min-flex mt-5p">
                      <strong>User: </strong>{{ getUserName(data) }}.
                      <strong>Role: </strong> {{ data.role | typeUser }}.
                      <strong>Source: </strong>
                      {{ getTypeSource(data.source, data.role) }}</span
                    >
                  </div>
                </div>

                <div
                  class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 text-right align-self-center"
                >
                  <div class="button-action" v-if="!data.notes">
                    <span
                      class="link d-flex align-items-center f-12 "
                      @click="addNote(data)"
                    >
                      <i class="flaticon-plus mr-1 "> </i> Add Note
                    </span>
                  </div>
                </div>
              </div>

              <div class="review" v-if="data.attributes_modified.length > 0">
                <div class="card-updates">
                  <ul class="list-updates">
                    <li
                      v-for="(item, index) in data.attributes_modified"
                      :key="index"
                    >
                      <label>{{ item.attribute_name }}:</label>

                      <span class="old" v-if="item.oldValue"
                        >{{ item.oldValue }}
                      </span>
                      <span class="old" v-else>Empty </span> |
                      <span class="new"> {{ item.newValue }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <span v-if="data.notes" class="span-notes">
                <strong>Note:</strong> {{ data.notes }}</span
              >
            </div>
          </div>
          <base-alert
            type="warning"
            class="info-min"
            v-if="histories.length === 0"
          >
            <i class="flaticon-warning mr-1"></i> History not available
          </base-alert>
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="outline-neutral mb-0"
          class="min-button"
          @click="closeModalHistory()"
          >Close</base-button
        >
      </template>
    </modal>

    <modal :show.sync="modalAddNotes" no-close-on-backdrop>
      <template slot="header">
        <h2 class="subtitle">Add Note</h2>
      </template>

      <div class="row">
        <div
          class="col-12 mt-3 mb-3"
          v-bind:class="{
            'is-invalid': $v.tempNote.$error
          }"
        >
          <label class="title-label">Note</label>
          <el-input
            v-model="tempNote"
            maxlength="200"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            show-word-limit
          >
          </el-input>

          <small class="invalid-feedback" v-if="$v.tempNote.$error"
            >Enter a Note</small
          >
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="outline-neutral mb-0"
          class="min-button"
          @click="closeModalNote()"
          >Close</base-button
        >

        <base-button
          type="primary ml-auto"
          class="min-button mb-0"
          @click="saveNote(tempItem._id, tempNote)"
          >Save</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import { DropdownMenu, DropdownItem, Dropdown, MessageBox } from "element-ui";
import Swal from "sweetalert2";
import { TablePlugin } from "bootstrap-vue";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { unauthorizedAction } from "../../../helpers/commons.helpers";

export default {
  name: "RateHistory",
  props: {
    tempRateId: {
      type: String,
      description: "id"
    },
    show: {
      type: Boolean
    }
  },
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [MessageBox.name]: MessageBox,
    TablePlugin
  },
  data() {
    return {
      rateId: null,
      histories: [],
      modalAddNotes: false,
      tempNote: "",
      tempItem: [],
      showModal: false,
      loader: false
    };
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showModal = current;
      },
      deep: true
    },
    tempRateId: {
      handler: async function(current, old) {
        if (current) {
          this.rateId = current;
          this.loader = true;
          await this.getHistoriesByRateId(this.rateId);
          this.loader = false;
        }
      },
      deep: true
    }
  },
  async created() {},
  methods: {
    async updateHistory(historyId, body) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.updateHistoryById(
          historyId,
          body,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "Your note has been saved succesfull",
            icon: "flaticon-check-3"
          });

          this.tempNote = "";
          this.tempItem = [];
          this.modalAddNotes = false;
          await this.getHistoriesByRateId(this.rateId);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      }
    },
    async saveNote(historyId, notes) {
      this.$v.tempNote.$touch();
      if (!this.$v.tempNote.$invalid) {
        let { value } = await Swal.fire({
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          title: "Save Note",
          html:
            "Are you sure you save this note? <br> This note cannot be modified",
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.updateHistory(historyId, { notes: notes });
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    async getHistoriesByRateId(rateId) {
      try {
        let { data } = await endpoint.rates.services.getHistoriesByRateId(
          rateId,
          100,
          1,
          this.sesion.token
        );
        if (data) {
          this.histories = data.docs;
        } else {
          this.histories = [];
        }
      } catch (error) {
        this.histories = [];
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      }
    },
    getUserName(history) {
      try {
        if (history.responsible.type === "Operators") {
          return `${history.responsible.ref.contactPerson.firstName} ${history.responsible.ref.contactPerson.lastName}`;
        } else if (history.responsible.type === "Users") {
          return `${history.responsible.ref.personal_info.first_name} ${history.responsible.ref.personal_info.last_name}`;
        } else {
          return "Unknown";
        }
      } catch (error) {
        return "Unknown";
      }
    },
    addNote(item) {
      this.tempItem = item;
      this.modalAddNotes = true;
    },
    closeModalNote() {
      this.tempNote = "";
      this.tempItem = [];
      this.modalAddNotes = false;
    },
    closeModalHistory() {
      this.showModal = false;
      this.$emit("close", false);
    },
    getIcon(status) {
      if ("Rate Updated" === status) {
        return "flaticon-pencil";
      } else if (status === "Rate Created") {
        return "flaticon-plus";
      } else {
        return "flaticon-rec";
      }
    },
    getBadge(status) {
      if ("Rate Updated" === status) {
        return "bg-updated";
      } else if (status === "Rate Created") {
        return "bg-new";
      } else {
        return "bg-draft";
      }
    },
    getTypeSource(type, role) {
      if (["rhomtrip", "rhombuss"].indexOf(type) > -1) {
        if (role === "supplier") {
          return "RhomTrip Suppliers";
        } else {
          return "RhomTrip Internal";
        }
      } else if (type === "dispatch") {
        return "RhomTrip Dispatch";
      } else if (type === "web") {
        return "RhomTrip Web";
      } else if (type === "driver-app") {
        return "RhomTrip Driver";
      } else if (type === "agency-app") {
        return "RhomTrip Partners";
      } else {
        return "-";
      }
    },
    formatDate(createdAt, timeZone) {
      return moment(createdAt)
        .tz(timeZone)
        .format("DD-MMM-YYYY");
    },
    formatTime(createdAt, timeZone) {
      return moment(createdAt)
        .tz(timeZone)
        .format("h:mm:ss");
    },
    ...mapMutations(["setLoad", "setSigOut"])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  filters: {
    typeUser(type) {
      if (type === "customer") {
        return "Customer";
      } else if (type === "travel_agency") {
        return "Partner";
      } else if (type === "business") {
        return "Business";
      } else if (type === "guest") {
        return "Guest";
      } else if (type === "supplier") {
        return "Supplier";
      } else if (type === "driver") {
        return "Driver";
      } else if (type === "admin") {
        return "Admin";
      } else if (type === "super_admin") {
        return "Super Admin";
      } else if (type === "manager") {
        return "Manager";
      } else if (type === "user") {
        return "User";
      } else if (type === "supplier_access") {
        return "Supplier Access";
      } else if (type === "dispatcher_access") {
        return "Dispatcher Access";
      } else if (type === "travel_access") {
        return "Agent";
      }
    }
  },
  validations: {
    tempNote: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(200)
    }
  }
};
</script>
